import classNames from "classnames";
import React from "react";

export const Error = () => (
  <div className={classNames("cw-p-2 cw-text-center cw-body-sm", "cw-text-warning")}>
    Failed to fetch history
  </div>
);
